"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_DETAIL = exports.OPEN_URL = exports.EXECUTE_FUNCTION = exports.CALL_SERVICE = exports.ACTION = void 0;
var EXECUTE_FUNCTION = exports.EXECUTE_FUNCTION = "EXECUTE_FUNCTION";
var OPEN_URL = exports.OPEN_URL = "OPEN_URL";
var CALL_SERVICE = exports.CALL_SERVICE = "CALL_SERVICE";
var SHOW_DETAIL = exports.SHOW_DETAIL = "SHOW_DETAIL";
var ACTION = exports.ACTION = "ACTION";